import { UserListComponent } from './user-list/user-list.component';
 
export const allPresentationalComponents = [UserListComponent];